import React, { useEffect, useState } from "react";
import axiosInterceptor from "../../../../helpers/Interceptor";

const blobCache = new Map();

const AuthenticatedImage = ({ url, alt, className, style }) => {
  const [src, setSrc] = useState(blobCache.get(url) || null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!url) {
      setSrc(null);
      return undefined;
    }
    const cached = blobCache.get(url);
    if (cached) {
      setSrc(cached);
      return undefined;
    }
    let cancelled = false;
    let createdObjectUrl = null;
    setError(false);
    axiosInterceptor
      .get(url, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        createdObjectUrl = URL.createObjectURL(res.data);
        blobCache.set(url, createdObjectUrl);
        setSrc(createdObjectUrl);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (error) {
    return <div className={className} style={{ ...style, display: "flex", alignItems: "center", justifyContent: "center", color: "#999", fontSize: "11px" }}>image unavailable</div>;
  }

  if (!src) {
    return <div className={className} style={{ ...style, background: "#222" }} />;
  }

  return <img src={src} alt={alt} className={className} style={style} draggable={false} />;
};

export default AuthenticatedImage;
